"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Form: {
    kind: 'Form'
  },
  Text: {
    kind: 'Text'
  },
  'Success Text': {
    props: {
      color: '--dark'
    }
  },
  'Error Text': {
    props: {
      color: '--red'
    }
  }
};
exports["default"] = _default;